import companyInformation from '../../assets/corporatePage/companyInformation.svg'
import crossDept from '../../assets/corporatePage/crossDept.svg'
// import automationInfo from '../../assets/corporatePage/automateInfo.svg'
import automationInfo from '../../assets/corporatePage/Frame 2087324845.svg'

import calendar from '../../assets/licenseManagementPage/calendar.svg'
import formfilling from '../../assets/licenseManagementPage/formFilling.svg'
import multipleLm from '../../assets/licenseManagementPage/multipleLm.svg'
import notifications from '../../assets/licenseManagementPage/notifications.svg'
import organizeLM from '../../assets/licenseManagementPage/organizeLM.svg'
import LMDashboard from '../../assets/licenseManagementPage/LMDashboard.svg'
import centralizeDoc from '../../assets/complianceAssurance/Name=Tailored Compliace management.svg'
import clientWorkspace from '../../assets/complianceAssurance/Name=Client workspace.svg'
import compliancedoc from '../../assets/complianceAssurance/Name=Easy accessable compliance documentation.svg'
import notification from '../../assets/complianceAssurance/Name=Reminders & notifications.svg'
import tools from '../../assets/consultantsAndAdvisors/illustrations-2.svg'
import workspaceManagement from '../../assets/consultantsAndAdvisors/illustrations-3.svg'
import centralDoc from '../../assets/consultantsAndAdvisors/illustrations-4.svg'
import reminder from '../../assets/consultantsAndAdvisors/illustrations-5.svg'



//corporate management
export const corporateManagementInfo = {
    imageArray: [],
    gap: "0.5rem",
    descriptionhead: "",
    title: "",
    icon: null,
    subtitle: <span>Simplify Your Corporate Data <br /> Management</span>,
    description: "Managing your company’s data across multiple departments. With RegTechFlow, you can efficiently store and manage all your corporate data in one secure platform, removing the repetitive burden of filling out forms for various corporate processes.",
    additionalText: "",
    buttonText: "",
    textColor: "#6200EE",
    paraColor: "#1E1E1E",
    width: "max-w-[980px]",
    descriptionClass: "max-w-full items-center",
    descriptionHidden: true,
  };

  export const corporateManagementFeature = [
    {
      head: 'Set up and store your company information once',
      description:
        `Whether it's for legal, finance, or operations, RegTechFlow securely stores your data for future use across any department.`,
      icon:companyInformation,
    },
    {
      head: 'Automate application creation for corporate processes',
      description:
        'Upload any application form or required documents, such as due diligence forms or bank account applications, and our platform will autofill and generate the necessary documentation for you.  ',
        icon:automationInfo,
    },
    {
      head: 'Cross-Department Collaboration',
      description:
        'Ensure that your legal, finance, and compliance teams work with the same up-to-date data, reducing errors and duplication of efforts.',
        icon:crossDept,
    },
  ]

  export const corporateManagementFeatures = [
    {
      title: "Centralized Data Management",
      description:
        "Centralizes and secures corporate data across legal, finance, and operations departments, reducing the complexity of managing information in multiple places.",
    },
    {
        title: "Enhanced Cross-Department Collaboration",
        description:
          "Facilitates collaboration between departments by ensuring everyone has access to the most up-to-date data, reducing errors and avoiding duplication of work.",
    },
    {
        title: "Automated Document Generation",
        description:
        "Automates the creation of applications, contracts, and other corporate documents, saving time and ensuring accuracy by auto-filling required forms and documents.",
    },
    {
        title: "Secure Data Management",
        description:
        "Ensures the security and confidentiality of sensitive company information during data management and collaboration processes.",
    },
    {
      title: "Automated Data Entry",
      description:
        "Eliminates the burden of repetitive data entry by securely storing company information for future use, automating the process across various corporate applications.",
    },
    {
        title: "Compliance and Deadline Alerts",
        description:
          "Provides reminders for important deadlines, such as expiring legal agreements or financial reports, helping companies stay compliant.",
    },
  ];

  //license management 
  export const licenseManagementInfo = {
    imageArray: [],
    gap: "0.5rem",
    descriptionhead: "",
    title: "",
    icon: null,
    subtitle: "Move Fast yet Stay Compliant with RegTechFlow",
    description: "Managing multiple licenses for various businesses and industries can be overwhelming, but with Regtechflow, it's never been simpler. Our platform is designed to help you apply for and manage multiple licenses across different companies all in one place, ensuring an organized, efficient process. Whether you're applying for new licenses, tracking renewals, or storing related documentation, Regtechflow streamlines the entire workflow.",
    additionalText: "",
    buttonText: "",
    textColor: "#6200EE",
    paraColor: "#1E1E1E",
    width: "max-w-[1058px]",
    descriptionClass: "max-w-full items-center",
    descriptionHidden: true,
  };
  
  export const licenseManagementFeature = [
      {
        head: 'Automatic Form-filling and Document Generation',
        description:
          'Once your company data is stored, RegTechFlow uses it to instantly fill out any license application and/or required documents, so you don’t have to.',
          icon:formfilling,
      },
    {
      head: 'Organize All License Documents',
      description:
        `The platform organizes everything needed for your license applications in one place, making it easier to manage your submissions.`,
      icon:organizeLM,
    },
    {
      head: 'License Management Dashboard',
      description:
        "Centralize and organize licenses across all your companies, with everything accessible from one easy-to-use dashboard.",
      icon:LMDashboard,
    },
    {
      head: 'Multiple License Management',
      description:
        "RegTechFlow alerts you when a license is approaching expiry, helping you stay compliant.",  
      icon:multipleLm,
    },
    {
        head: 'Never Miss a Renewal Date',
      description:
        "RegTechFlow alerts you when a license is approaching expiry, helping you stay compliant.",  
      icon:calendar,
    },
    {
      head: 'Receive Notifications',
      description:
        'Receive notifications about license and documents expiry to maintain continuous operations.',
        icon:notifications,
    },
]

export const licenseManagementFeatures = [
      {
      title: "Automated License Applications",
      description:
        "Centralizes and secures corporate data across legal, finance, and operations departments, reducing the complexity of managing information in multiple places.",
    },
    {
        title: "Centralized License Document Storage",
        description:
        "Centralizes and organizes all license-related documents in one place, making it easier to manage and submit applications efficiently.",
    },
    {
      title: "Automated Renewal Alerts",
      description:
      "Sends automatic alerts when licenses are approaching expiration, helping companies avoid compliance issues by ensuring timely renewals.",
    },
    {
      title: "Multi-License Management",
      description:
      "Supports unlimited license applications for different companies and industries at the same time, with the ability to track all application statuses in one centralized dashboard for streamlined management.",
    },
]

//compliance-management
export const complianceManagementInfo = {
    imageArray: [],
    gap: "0.5rem",
    descriptionhead: "",
    title: "",
    icon: null,
    subtitle: "Your trusted partner in compliance",
    description: "Managing regulatory compliance can be complex, but RegTechFlow simplifies the process by consolidating all your compliance obligations into one easy-to-use platform. Whether you're navigating industry-specific regulations, country-specific rules, or both, RegTechFlow helps you stay on top of everything.",
    additionalText: "",
    buttonText: "",
    textColor: "#6200EE",
    paraColor: "#1E1E1E",
    width: "max-w-4xl",
    descriptionClass: "max-w-full items-center",
    descriptionHidden: true,
};

  export const complianceManagementFeature = [
      {
        head: 'Tailored Compliance Management',
        description:
        'Set up your compliance rules according to local regulations or industry standards, and RegTechFlow will manage reminders and deadlines for you.',
          icon:centralizeDoc,
        },
        {
            head: 'Easily Accessible Compliance Documentation',
      description:
      `Store and organize all your compliance-related documentation for easy access whenever you need it.`,
      icon:compliancedoc,
    },
    {
        head: 'Automated Compliance Tracking',
      description:
        "Our platform keeps you updated on upcoming compliance reporting requirements, filings, and audits.",
      icon:clientWorkspace,
    },
    {
      head: 'Automatic Alerts for Compliance Documents',
      description:
        "Receive reminders for expiring compliance documents and submissions, ensuring you're always on track.",  
        icon:notification,
    },
]
export const complianceManagementProblemSolved = [
      {
      title: "Customizable Compliance Processes",
      description:
        "Allows you to set up compliance processes according to local regulations or industry standards, with automatic management of reminders and deadlines.",
    },
    {
        title: "Organized Compliance Documentation",
        description:
        "Organizes and stores all compliance-related documentation in one easily accessible place, so you can quickly retrieve any needed document.",
    },
    {
      title: "Automated Compliance Tracking",
      description:
        "Automates compliance tracking, keeping you informed of upcoming reporting, filings, and audits without manual effort.",
    },
    {
      title: "Automatic Deadline Alerts",
      description:
      "Sends automatic alerts for expiring compliance documents and upcoming submissions, ensuring you stay on track and avoid penalties.",
    },
]


//Consultant-and-advisors
export const consultantAndAdvisorsInfo = {
    imageArray: [],
    gap: "0.5rem",
    descriptionhead: "",
    title: "",
    icon: null,
    subtitle: "We’ve built RegTechFlow with consultants and advisors in mind",
    description: "Use the platform to automate processes and add value to your clients by offering:",
    additionalText: "",
    buttonText: "",
    textColor: "#6200EE",
    paraColor: "#1E1E1E",
    width: "max-w-xl mb-2",
    descriptionClass: "max-w-full items-center",
    descriptionHidden: true,
  };

  export const consultantsAndAdvisorsFeatures = [
    {
      head: 'Automation Tools for Your Clients',
      description:
      'Manage multiple clients efficiently by automating corporate, licensing, and compliance tasks.',
        icon:tools,
      },
      {
          head: "Client Workspace Management",
    description:
    `RegTechFlow makes it easy to monitor the status of your clients’ compliance needs, corporate data, and ongoing regulatory obligations.`,
    icon:workspaceManagement,
  },
  {
      head: 'Centralized Document Management',
    description:
      "Store all client data securely, and simplify document sharing and collaboration across internal employees.",
    icon:centralDoc,
  },
  {
    head: 'Reminders and Notifications',
    description:
      "Automate reminders for your clients' expiring documents or compliance tasks, ensuring nothing falls through the cracks.",  
      icon:reminder,
  },
]

export const consultantAndAdvisorsInfoSolutions = [
    {
    title: "Automated Client Management",
    description:
      "Streamlines the management of multiple clients by automating corporate, licensing, and compliance tasks, saving time and effort.",
  },
  {
      title: "Centralized Client Workspace Monitoring",
      description:
      "Offers a single platform to easily track the status of clients' compliance needs, corporate data, and regulatory obligations.",
  },
  {
    title: "Secure Document Management",
    description:
      "Centralizes and secures all client data, simplifying document storage, sharing, and collaboration with internal teams.",
  },
  {
    title: "Automated Reminders and Notifications",
    description:
    "Provides automated reminders for expiring documents and compliance tasks, ensuring clients stay compliant and on top of deadlines.",
  },
]